<template>
    <div class="waba-supsis-message-template-status-update">
        <div class="title">Whatsapp Business API V2 mesaj şablonu durumu güncellendi</div>
        <div class="meta">
            <div v-if="$_.get(activity, 'payload.originalEvent')">
                <b>Durum</b>: <span :class="getStatusClass($_.get(activity, 'payload.originalEvent'))">{{ $_.get(activity, "payload.originalEvent") }}</span>
            </div>
            <div><b>Kanal ID</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>Şablon Adı</b>: {{ $_.get(activity, "payload.message_template_name") }}</div>
            <div><b>Şablon ID</b>: {{ $_.get(activity, "payload.message_template_id") }}</div>
            <div><b>Dil</b>: {{ $_.get(activity, "payload.message_template_language") }}</div>
            <div v-if="$_.get(activity, 'payload.message_template_category')">
                <b>Kategori</b>: {{ $_.get(activity, "payload.message_template_category") }}
            </div>
            <div v-if="$_.get(activity, 'payload.reason') && $_.get(activity, 'payload.reason') !== 'NONE'">
                <b>Sebep</b>: {{ $_.get(activity, "payload.reason") }}
            </div>
            <div v-if="$_.get(activity, 'payload.previous_quality_score')">
                <b>Önceki Kalite Skoru</b>: <span :class="getQualityClass($_.get(activity, 'payload.previous_quality_score'))">{{ $_.get(activity, "payload.previous_quality_score") }}</span>
            </div>
            <div v-if="$_.get(activity, 'payload.new_quality_score')">
                <b>Yeni Kalite Skoru</b>: <span :class="getQualityClass($_.get(activity, 'payload.new_quality_score'))">{{ $_.get(activity, "payload.new_quality_score") }}</span>
            </div>
        </div>
        <details class="raw">
            <summary>Ham payload</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisMessageTemplateStatusUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
    methods: {
        getQualityClass(quality) {
            if (quality === "GREEN") return "text-success";
            if (quality === "YELLOW") return "text-warning";
            if (quality === "RED") return "text-danger";
            return "";
        },
        getStatusClass(status) {
            if (status === "APPROVED" || status === "REINSTATED") return "text-success";
            if (status === "PENDING" || status === "IN_APPEAL" || status === "FLAGGED") return "text-warning";
            if (status === "REJECTED" || status === "PAUSED" || status === "DISABLED" || status === "DELETED" || status === "PENDING_DELETION") return "text-danger";
            return "";
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-message-template-status-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .text-success {
        color: #28a745;
        font-weight: 600;
    }
    .text-warning {
        color: #ffc107;
        font-weight: 600;
    }
    .text-danger {
        color: #dc3545;
        font-weight: 600;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
